import { writable } from 'svelte/store';

export const userbaseStore = writable(null);
export const InventoryStore = writable([]);
export const LogStore = writable([]);
export const ArticleStore = writable([]);

export const dbNameInventory = "inventory";